// biome-ignore-all lint/plugin/no-unlabeled-form-inputs: legacy unlabeled inputs, burn-down tracked in HTUI-392
import type { FC } from "react";

import { CodeIcon, Select, TableIcon, ModelIcon } from "@hightouch/htui";

import {
  BrowserImage,
  DbtImage,
  LookerImage,
  SigmaImage,
  SQLImage,
  TableImage,
} from "src/components/models";
import { QueryType } from "src/types/models";
import { DBTIcon, LookerIcon, SigmaIcon } from "src/ui/icons";

export const QUERY_TYPE_OPTIONS = {
  [QueryType.RawSql]: {
    label: "SQL query",
    description: "Filter, transform, and join your data using a SQL query.",
    image: SQLImage,
    icon: CodeIcon,
  },
  [QueryType.DbtModel]: {
    label: "dbt model",
    description: "Use a table or materialized view generated by dbt.",
    image: DbtImage,
    icon: DBTIcon,
  },
  [QueryType.DbtCloudModel]: {
    label: "dbt Cloud model",
    description: "Use a table or materialized view generated by dbt Cloud.",
    image: DbtImage,
    icon: DBTIcon,
  },
  [QueryType.LookerLook]: {
    label: "Looker model",
    description:
      "Convert a Look into a SQL query that runs on your data source.",
    image: LookerImage,
    icon: LookerIcon,
  },
  [QueryType.Sigma]: {
    label: "Sigma model",
    description:
      "Convert a workbook into a SQL query that runs on your data source.",
    image: SigmaImage,
    icon: SigmaIcon,
  },
  [QueryType.Table]: {
    label: "Table selector",
    description:
      "Read all rows from an existing table or view in your database.",
    image: TableImage,
    icon: TableIcon,
  },
  [QueryType.Custom]: {
    label: "Browse",
    description: "Select a file, spreadsheet, collection, or other dataset.",
    image: BrowserImage,
    icon: ModelIcon,
  },
};

export const HIDDEN_QUERY_TYPE_OPTIONS = {
  [QueryType.JourneyNode]: {
    label: "Journey tile",
    icon: ModelIcon,
  },
  [QueryType.DecisionEngine]: {
    label: "Decision engine",
    icon: ModelIcon,
  },
};

type Props = {
  supportedQueries: string[];
  type: QueryType;
  onChange: (type: QueryType) => void;
};

export const QueryTypeMenu: FC<Readonly<Props>> = ({
  supportedQueries,
  type,
  onChange,
}) => {
  const options = supportedQueries
    .filter((type) => {
      return QUERY_TYPE_OPTIONS[type];
    })
    .map((type) => {
      const config = QUERY_TYPE_OPTIONS[type];
      return {
        value: type,
        label: config.label,
        icon: config.icon,
      };
    });

  if (type === QueryType.JourneyNode || type === QueryType.DecisionEngine) {
    options.push({
      value: type,
      label: HIDDEN_QUERY_TYPE_OPTIONS[type].label,
      icon: HIDDEN_QUERY_TYPE_OPTIONS[type].icon,
    });
  }

  return (
    <Select
      width="3xs"
      value={type}
      optionAccessories={(option) => ({
        leftAccessory: {
          type: "icon",
          icon: option.icon,
        },
      })}
      onChange={(value) => {
        if (value) {
          onChange(value);
        }
      }}
      options={options}
    />
  );
};
